import React from 'react';
import StripeConnectForm from './StripeConnectForm';
import StripeCountryForm from './StripeCountryForm';
import ReactLoading from 'react-loading';
import PayFastConnectForm from './StripeConnectForm/PayFastConnectForm';

function StripeDetailForm(props) {
    const {
        submitPayFastInformation,
        submitStripeInformation,
        initialized,
        isLoading,
        userInfo,
    } = props;
    const {
        StripeCountryCode,
        IsStripeConnectComplete,
        IsStripeConnectExternalAccountDue,
        IsStripeConnectOtherRequirementDue,
        IsStripeConnectRequired = false,
    } = userInfo.basicInfo;

    if (!IsStripeConnectRequired) {
        return '';
    }

    if (!initialized) {
        return (
            <div className='card card--border card--form card--stackable'>
                <ReactLoading
                    className='button__spinner'
                    type='spin'
                    color='black'
                    height={50}
                    width={50}
                />
            </div>
        );
    }

    return (
        <React.Fragment>
            <div style={{ marginBottom: 40 }}>
                {window.localeCountry != 'South Africa' ? (
                    userInfo.basicInfo.StripeCountryCode ? (
                        <StripeConnectForm
                            {...props}
                            handleFormSubmission={submitStripeInformation}
                            countryCode={StripeCountryCode}
                            isCompleted={IsStripeConnectComplete}
                            requireInternalDetails={
                                IsStripeConnectExternalAccountDue
                            }
                            redirectToStripe={
                                IsStripeConnectOtherRequirementDue
                            }
                        />
                    ) : (
                        <StripeCountryForm
                            {...props}
                            handleFormSubmission={submitStripeInformation}
                        />
                    )
                ) : (
                    <PayFastConnectForm
                        {...props}
                        handleFormSubmission={submitPayFastInformation}
                        countryCode={StripeCountryCode}
                        isCompleted={IsStripeConnectComplete}
                        requireInternalDetails={
                            IsStripeConnectExternalAccountDue
                        }
                        redirectToStripe={IsStripeConnectOtherRequirementDue}
                    />
                )}
            </div>
        </React.Fragment>
    );
}

export default StripeDetailForm;
